<template>
  <div id="app">
    <template>
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </template>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isAppReady: false
    }
  }
}
</script>
<style>
  @import url("https://fonts.googleapis.com/css?family=Poppins");

  html,
  body {
    margin: 0;
  }
  #app {
    font-family: "Poppins", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  html {
    font-family: "Poppins", sans-serif;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
